import React from 'react';

/* Icons */
import iDealIcon from '~/../symbols/iDeal.svg';
import StarIcon from '~/../symbols/star.svg';
import StarBorderedIcon from '~/../symbols/star-bordered.svg';
import StarHalfBorderedIcon from '~/../symbols/star-half-bordered.svg';
import CheckIcon from '~/../symbols/check.svg';

/* Common */
import { Icon } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionInfo({ usps, rating, flowName }) {
    return (
        <div className="card card--info mx-n6 mx-sm-0">
            <div className="card-body">
                {flowName === 'buy_online_v2' && (
                    <div className="d-flex align-items-center mb-1">
                        <Icon
                            size={10}
                            className={`btn__icon icon icon--ideal mr-2`}
                            url={iDealIcon?.url}
                        />
                        <p className="font-weight-bold">{trans('app.flow.purchase_available')}</p>
                    </div>
                )}
                <div className="row gutters-2">
                    {(rating > 0) && (
                        <div className="col-12">
                            <a href="https://www.wensink.nl/over-ons/reviews" className="card__rating d-flex align-items-center">
                                {[...Array(Math.floor((Math.round(rating * 2)) / 2))].map((choice, index) => (
                                    <Icon
                                        size={20}
                                        key={index}
                                        className="text-primary"
                                        url={StarIcon?.url}
                                    />
                                ))}
                                {Math.round(rating * 2) % 2 == 1 && (
                                    <Icon
                                        size={20}
                                        className="text-primary"
                                        url={StarHalfBorderedIcon?.url}
                                    />
                                )}
                                {(Math.floor((Math.round(rating * 2)) / 2) + Math.round(rating * 2) % 2) < 5 && (Math.round(rating) < 5) && [...Array(5 - (Math.floor((Math.round(rating * 2)) / 2) + Math.round(rating * 2) % 2))].map((choice, index) => (
                                    <Icon
                                        size={20}
                                        key={index}
                                        className="text-primary"
                                        url={StarBorderedIcon?.url}
                                    />
                                ))}
                                <p className="font-weight-bold ml-2">{rating}/5.0</p>
                            </a>
                        </div>
                    )}
                    {(usps && usps.length > 0) && (
                        <div className="col-12">
                            <ul className="list list--usps">
                                {usps.map((usp, index) => (
                                    <li key={index} className="list__item">
                                        <Icon
                                            size={12}
                                            className={`btn__icon icon mr-2`}
                                            url={CheckIcon?.url}
                                        />
                                        {usp.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
